/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}focus-indicator`;
const observedAttributes = {
    TARGET: 'target',
    ACTIVE: 'active',
    INWARD: 'inward',
    CIRCULAR: 'circular',
    ALLOW_FOCUS: 'allow-focus',
    FOCUS_MODE: 'focus-mode'
};
const attributes = {
    ...observedAttributes
};
const defaults = {
    FOCUS_MODE: 'focusin'
};
export const FOCUS_INDICATOR_CONSTANTS = {
    elementName,
    attributes,
    defaults
};
